import styled from 'styled-components';
import { Body } from '@cambridgeassessment/cambridge-ui';

export const StyledLabel = styled(Body)`
  text-align: right;
  padding-right: 20px;
  font-size: 20px;
  color: black;
`;
